export type RentalAssetFamily = 'lodging' | 'property' | 'vehicle' | 'equipment' | 'space';

const FAMILY_LABELS: Record<RentalAssetFamily, string> = {
  lodging: 'Hébergement',
  property: 'Immobilier',
  vehicle: 'Véhicules & mobilité',
  equipment: 'Matériel',
  space: 'Espaces',
};

export function rentalFamilyLabel(family: string | null | undefined): string | null {
  return family && family in FAMILY_LABELS ? FAMILY_LABELS[family as RentalAssetFamily] : null;
}

export function rentalWorkspaceLabel({
  category,
  profile,
  families,
}: {
  category?: string | null;
  profile?: string | null;
  families?: readonly string[] | null;
}): string {
  const configuredFamilies = (families ?? []).filter((family) => rentalFamilyLabel(family));
  if (configuredFamilies.length > 1) return 'Location & mobilité';

  const configuredFamily = rentalFamilyLabel(configuredFamilies[0]);
  if (configuredFamily) return configuredFamily;

  if (profile === 'vehicle_fleet' || category === 'vehicules_mobilite') {
    return 'Véhicules & mobilité';
  }
  if (profile === 'rental_property') return 'Immobilier';
  if (profile === 'mixed_assets') return 'Location & mobilité';

  return 'Hébergement';
}
